import { useInfiniteQuery } from '@tanstack/react-query'
import effects from 'app/effects/effects'

const DEFAULT_META = {
  currentPage: 1,
  lastPage: undefined,
}

export const SUBSCRIBER_GROUPS_QUERY_KEY = 'subscriber-groups'
const SUBSCRIBER_GROUPS_STALE_TIME = 20 * 60 * 1000 // cache for 20 minutes
const SUBSCRIBER_GROUPS_INITIAL_PAGE = 1

export const buildSubscriberGroupsQueryKey = ({ type, limit, search }) => [
  SUBSCRIBER_GROUPS_QUERY_KEY,
  type,
  limit,
  search,
]

export const useSubscriberGroupsQuery = ({
  type,
  limit,
  search,
  enabled = true,
  staleTime = SUBSCRIBER_GROUPS_STALE_TIME,
}) => {
  return useInfiniteQuery({
    queryKey: buildSubscriberGroupsQueryKey({ type, limit, search }),
    queryFn: async ({ pageParam = SUBSCRIBER_GROUPS_INITIAL_PAGE }) => {
      const response = await effects.apis.getGroupForSubscriberAttach({
        type,
        page: pageParam,
        limit,
        search,
      })
      const data = response?.data ?? []
      return {
        data,
        meta: response?.meta ?? { currentPage: pageParam, lastPage: pageParam },
      }
    },
    initialPageParam: SUBSCRIBER_GROUPS_INITIAL_PAGE,
    getNextPageParam: (lastPage) => {
      const meta = lastPage?.meta ?? DEFAULT_META
      return meta.lastPage && meta.currentPage < meta.lastPage
        ? meta.currentPage + 1
        : undefined
    },
    enabled,
    staleTime,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  })
}
